export default "__VITE_ASSET__3luqrg8R__"